export const isAdminDeleteEnabled = () =>
  process.env.NEXT_PUBLIC_ADMIN_DELETE_ENABLED === "true"

export const isFolderRefreshEnabled = () =>
  process.env.NEXT_PUBLIC_FOLDER_REFRESH_ENABLED === "true"

export const isJsonViewEnabled = () =>
  process.env.NEXT_PUBLIC_JSON_VIEW_ENABLED === "true"
